import { render, staticRenderFns } from "./my-presentation-box.vue?vue&type=template&id=a8397a14&scoped=true&"
import script from "./my-presentation-box.vue?vue&type=script&lang=js&"
export * from "./my-presentation-box.vue?vue&type=script&lang=js&"
import style0 from "./my-presentation-box.vue?vue&type=style&index=0&id=a8397a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8397a14",
  null
  
)

export default component.exports